import React from 'react'
import {TableCell, TableRow, Tooltip, withStyles} from '@material-ui/core';
import styles from '../styles'
import {withTranslation} from 'react-i18next';
import {compose} from 'recompose';
import PropTypes from 'prop-types';


function ProductHeaderEdit(props) {

  const {className, t} = props;

  return (
    <TableRow className={className}>
      <TableCell>{t('productType')}</TableCell>
      <TableCell>{t('productBoxType')}</TableCell>
      <TableCell>{t('productBoxNumber')}</TableCell>
      <TableCell>{t('productAmount')}</TableCell>
      <Tooltip title={t('productPerUnit')}>
        <TableCell>{t('productVolume')}</TableCell>
      </Tooltip>
      <Tooltip title={t('productPerUnit')}>
        <TableCell>{t('productWeight')}</TableCell>
      </Tooltip>
      <TableCell>{t('productDescription')}</TableCell>
      <TableCell/>
    </TableRow>
  );
}


ProductHeaderEdit.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired
}
;

export default compose(withStyles(styles), withTranslation())(ProductHeaderEdit);
